import { createApp } from '@backstage/frontend-defaults';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import appVisualizerPlugin from '@backstage/plugin-app-visualizer';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import opsAgentPlugin from '@internal/plugin-ops-agent';
import { navModule } from './modules/nav';
import { fbetaThemeExtension } from './theme';

export default createApp({
  features: [
    apiDocsPlugin,
    appVisualizerPlugin,
    catalogPlugin,
    catalogGraphPlugin,
    catalogImportPlugin,
    kubernetesPlugin,
    notificationsPlugin,
    opsAgentPlugin,
    orgPlugin,
    scaffolderPlugin,
    searchPlugin,
    signalsPlugin,
    techdocsPlugin,
    userSettingsPlugin,
    navModule,
    fbetaThemeExtension,
  ],
});
